module.exports = __webpack_public_path__ + "static/media/4.761be4a1.jpg";